function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import _ from "underscore";
import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
var any = PropTypes.any,
    string = PropTypes.string,
    func = PropTypes.func,
    bool = PropTypes.bool,
    number = PropTypes.number; // this is an unstyled input that...
// * onChange is passed new value directly
// * debounced by 200ms by default (prop = debounceTimeout)
// * focusOnMount prop is available
// * console.error when uncontrolled (and will intentionally behave oddly)

var warn = function warn(propValue, stateValue) {
  window.console.error("value mismatch. Input should be controlled", {
    propValue: propValue,
    stateValue: stateValue
  });
};

var focusRef = function focusRef(ref) {
  if (ref && ref.current && typeof ref.current.focus === "function") {
    ref.current.focus();
  }
};

var propTypes = {
  className: string,
  onChange: func.isRequired,
  onChangeEvent: func,
  value: string,
  debounceTimeout: number,
  focusOnMount: bool,
  forwardedRef: any
};

var PROP_KEYS = _.keys(propTypes);

var Input = /*#__PURE__*/function (_React$Component) {
  _inherits(Input, _React$Component);

  var _super = _createSuper(Input);

  function Input() {
    var _this;

    _classCallCheck(this, Input);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      value: _this.props.value,
      ahead: false
    });

    _defineProperty(_assertThisInitialized(_this), "inputRef", /*#__PURE__*/React.createRef());

    _defineProperty(_assertThisInitialized(_this), "sendChange", function () {
      if (!_this.unmounted) {
        _this.props.onChange(_this.state.value);

        _this.setState(function () {
          return {
            ahead: false
          };
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "clearTimeout", function () {
      _this.timeout && _this.timeout.cancel && _this.timeout.cancel();
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (evt) {
      var value = evt.target.value;

      _this.props.onChangeEvent(evt);

      _this.clearTimeout();

      _this.setState(function () {
        return {
          value: value,
          ahead: true
        };
      });

      _this.timeout = _this.debouncedSendChange();
    });

    return _this;
  }

  _createClass(Input, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.warn = _.once(warn);
      this.debouncedSendChange = _.debounce(this.sendChange, this.props.debounceTimeout);

      if (this.props.focusOnMount) {
        focusRef(this.props.forwardedRef || this.inputRef);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unmounted = true;
      this.clearTimeout();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;

      if (prevProps.value !== this.props.value) {
        this.setState(function (state) {
          return {
            value: _this2.props.value
          };
        });
      }

      if (prevState.ahead && !this.state.ahead) {
        if (this.state.value !== this.props.value) {
          this.warn(this.props.value, this.state.value);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var rest = _.omit(this.props, PROP_KEYS);

      var value = this.state.ahead ? this.state.value : this.props.value;
      return /*#__PURE__*/React.createElement("input", _extends({}, rest, {
        ref: this.props.forwardedRef || this.inputRef,
        className: classNames("et--input", this.props.className),
        value: value || "",
        onChange: this.handleChange
      }));
    }
  }]);

  return Input;
}(React.Component);

_defineProperty(Input, "displayName", "Input");

_defineProperty(Input, "propTypes", propTypes);

_defineProperty(Input, "defaultProps", {
  onChange: _.noop,
  onChangeEvent: _.noop,
  value: "",
  debounceTimeout: 200
});

export default /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Input, _extends({}, props, {
    forwardedRef: ref
  }));
});